import { ReturnHotKeyIcon } from '@modules/common/components/HotKeyIcons';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { useHotkey } from '@modules/common/hooks';
import { ArrowBackRounded } from '@mui/icons-material';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
  alpha,
} from '@mui/material';
import { SlackChannelInput } from 'generated/graphql';

interface PrivateSlackChannelConfirmationModalProps {
  onConfirm: () => void;
  channels: SlackChannelInput[];
}

export const PrivateSlackChannelConfirmationModal = ({
  onConfirm,
  channels,
}: PrivateSlackChannelConfirmationModalProps) => {
  const { closeModal } = useMuiModalContext();

  const confirmAndSave = () => {
    onConfirm();
    closeModal();
  };

  useHotkey({
    hotkey: 'enter',
    onHotkey: confirmAndSave,
    isHotKeyDisabled: false,
    actionTitle: 'Confirm Slack Subscription',
  });

  return (
    <>
      <DialogTitle>Hold up! Have you configured Slack correctly?</DialogTitle>
      <Divider light />
      <DialogContent>
        <Stack spacing={3}>
          <Typography>
            To enable Enterpret to send reports, please make sure the '
            <Box component="span" fontWeight="bold">
              Enterpret Bot
            </Box>
            ' is added to the following private Slack channels:{' '}
          </Typography>
          <Box
            sx={{
              bgcolor: (theme) => alpha(theme.palette.text.primary, 0.05),
              borderRadius: 1,
              maxHeight: 200,
              overflowY: 'auto',
              p: 1,
              py: 1.5,
            }}
          >
            <Stack
              component="ul"
              sx={{
                pl: 2,
                pb: 0,
                mb: 0,
              }}
              spacing={0.5}
            >
              {channels.map((channel) => (
                <Typography key={channel.id} variant="body2" component="li">
                  <Box component="span">{channel.name}</Box>
                </Typography>
              ))}
            </Stack>
          </Box>
          <Typography>Would you like to proceed?</Typography>
        </Stack>
      </DialogContent>
      <Divider light />
      <DialogActions sx={{ my: 1, mx: 2 }}>
        <Button
          variant="outlined"
          onClick={() => closeModal()}
          startIcon={<ArrowBackRounded />}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          onClick={confirmAndSave}
          endIcon={<ReturnHotKeyIcon />}
        >
          Confirm And Save
        </Button>
      </DialogActions>
    </>
  );
};
